import { PaymentProviderTemplateOptions, ProviderName } from '@fgb/core';
import { PaymentCloverComponent } from './payment-clover/payment-clover.component';
import { PaymentGoAheadPayComponent } from './payment-go-ahead-pay/payment-go-ahead-pay.component';
import { PaymentBraintreeComponent } from './payment-braintree/payment-braintree.component';

/**
 * List of payment provider templates available in the portal component library to be used by the PAYMENT_TEMPLATES injection token.
 */
export const paymentTemplates: Partial<Record<ProviderName, PaymentProviderTemplateOptions>> = {
  [ProviderName.Clover]: {
    component: PaymentCloverComponent,
  },
  [ProviderName.GoAheadPay]: {
    component: PaymentGoAheadPayComponent,
  },
  [ProviderName.BrainTree]: {
    component: PaymentBraintreeComponent,
  },
};

/**
 * Helper function to build payment templates by merging custom templates with the default ones.
 * @example
 * ```typescript
 *
 * provideAppConfig({
 *      dateOptions: {
 *        LongDateFormat: 'MMM D, yyyy h:mma',
 *     },
 *      defaultCountry: 'United States',
 *      paymentTemplates: buildPaymentTemplates({
 *         [ProviderName.CustomProvider]: {
 *            component: CustomPaymentComponent,
 *        }
 *      }),
 *
 *
 * ```
 */
export function buildPaymentTemplates(
  templates: Partial<Record<ProviderName, PaymentProviderTemplateOptions>> = {}
): Partial<Record<ProviderName, PaymentProviderTemplateOptions>> {
  return {
    ...paymentTemplates,
    ...templates,
  };
}
